import * as focusTrap from 'focus-trap';
import {
    enableBodyScroll,
    disableBodyScroll
} from '@/helpers/bodyScrollLockWrapper';

const drawersInit = () => {
    const drawerToggles = document.querySelectorAll('[data-drawer-toggle]');
    if (!drawerToggles?.length) {
        return;
    }

    const drawers = document.querySelectorAll('[data-drawer]');
    if (!drawers?.length) {
        return;
    }

    drawers.forEach((drawer) => {
        document.body.appendChild(drawer);

        const drawer_id = drawer.dataset.drawer;
        if (!drawer_id) {
            return;
        }

        const toggleBtns = document.querySelectorAll(`[data-drawer-toggle="${ drawer_id }"]`);
        if (!toggleBtns?.length) {
            return;
        }

        const closeBtns = drawer.querySelectorAll('[data-drawer-close]');

        const trap = focusTrap.createFocusTrap(drawer);

        function openDrawer() {
            toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', true));

            if (closeBtns?.length) {
                closeBtns.forEach(btn => btn.setAttribute('aria-expanded', true));
            }

            drawer.classList.add('drawer-new--opened');

            trap.activate();

            const container = drawer.querySelector('[data-drawer-container]');

            disableBodyScroll(container ?? drawer);
        }

        function closeDrawer() {
            toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', false));

            if (closeBtns?.length) {
                closeBtns.forEach(btn => btn.setAttribute('aria-expanded', false));
            }

            trap.deactivate();

            drawer.classList.remove('drawer-new--opened');

            const container = drawer.querySelector('[data-drawer-container]');

            enableBodyScroll(container ?? drawer);
        }

        function initDrawerToggleBtns() {
            toggleBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    openDrawer();
                });
            });
        }

        function initDrawerClose() {
            drawer.addEventListener('click', (e) => {
                const drawerContainer = e.target.closest('[data-drawer-container]');
                const drawerCloseButton = e.target.closest('[data-drawer-close]');
                if (drawerContainer && !drawerCloseButton) {
                    return;
                }

                closeDrawer();
            });

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    closeDrawer();
                }
            });
        
            document.addEventListener('drawers:close', () => {
                closeDrawer();
            });
        }

        initDrawerToggleBtns();
        initDrawerClose();
    });
};

document.addEventListener('DOMContentLoaded', () => {
    drawersInit();
});
